import { Product, TranslationProduct } from "utils/types/util.types";
import translationPlJSON from "utils/locales/pl/translation.json";
import translationEnJSON from "utils/locales/en/translation.json";

export const email = "kontakt@lark-stretch.pl";
export const phone = "+48 697 353 111";

export const products: Product[] = [
	{
		"id": 1,
		"textId": "stretch",
		"name": "Folia Stretch Jumbo",
		"image": require("assets/images/products/jumbo.png"),
		"basicInformationImage": require("assets/images/products/jumbo-cropped.png"),
	},
	{
		"id": 2,
		"textId": "machine",
		"name": "Folia Maszynowa",
		"image": require("assets/images/products/machine.png"),
		"basicInformationImage": require("assets/images/products/machine-cropped.png"),
	},
	{
		"id": 3,
		"textId": "hand",
		"name": "Folia Stretch Ręczna",
		"image": require("assets/images/products/hand.png"),
		"basicInformationImage": require("assets/images/products/hand-cropped.png"),
	},
	{
		"id": 4,
		"textId": "miniRap",
		"name": "Mini rap",
		"image": require("assets/images/products/mini-rap.png"),
		"basicInformationImage": require("assets/images/products/mini-rap-cropped.png"),
	},
	{
		"id": 5,
		"textId": "preStretch",
		"name": "Pre stretch",
		"image": require("assets/images/products/pre-stretch.png"),
		"basicInformationImage": require("assets/images/products/pre-stretch-cropped.png"),
	},
	{
		"id": 6,
		"textId": "hood",
		"name": "Kaptury",
		"image": require("assets/images/products/hoods.png"),
		"basicInformationImage": require("assets/images/products/hoods-cropped.png"),
	},
	{
		"id": 7,
		"textId": "accessories",
		"name": "Akcesoria",
		"image": require("assets/images/products/accessories.png"),
		"basicInformationImage": require("assets/images/products/accessories-cropped.png"),
	},
	{
		"id": 8,
		"textId": "stalco",
		"name": "Stalco",
		"image": require("assets/images/products/stalco.png"),
		"basicInformationImage": require("assets/images/products/stalco-basic.jpeg"),
		"banner": require("assets/images/products/stalco-banner.png"),
		"gallery": [
			require("assets/images/products/stalco-product-1.jpeg"), require("assets/images/products/stalco-product-2.jpeg"), require("assets/images/products/stalco-product-3.jpeg"), require("assets/images/products/stalco-product-4.jpeg"), require("assets/images/products/stalco-product-5.jpeg"), require("assets/images/products/stalco-product-6.jpeg"), require("assets/images/products/stalco-product-7.jpeg"), require("assets/images/products/stalco-product-8.jpeg"), require("assets/images/products/stalco-product-9.jpeg")
		]
	},
];

//Only for JSON products type check
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const productTranslationsPl: { [ K in keyof typeof translationPlJSON.products ]: TranslationProduct } = translationPlJSON.products;
const productTranslationsEN: { [ K in keyof typeof translationPlJSON.products ]: TranslationProduct } = translationEnJSON.products;
